<div class="option-picker">
  <div class="option-picker-content">
    <div class="option-picker-header">
      <img
        src="assets/legal-resources-logo.png"
        alt="Legal Resources"
        class="option-picker-logo"
      />
      <h1 class="option-picker-title">{{ title() }}</h1>
      @if (subtitle()) {
        <p class="option-picker-subtitle">{{ subtitle() }}</p>
      }
    </div>

    @if (loading()) {
      <div class="loading-state">
        <mat-spinner diameter="48"></mat-spinner>
        <p class="loading-text">Loading...</p>
      </div>
    } @else if (errorMessage()) {
      <div class="error-state">
        <p class="error-text">{{ errorMessage() }}</p>
      </div>
    } @else {
      <div class="option-picker-search">
        <div class="search-input-wrapper">
          <mat-icon class="search-icon">search</mat-icon>
          <input
            type="text"
            class="search-input"
            [placeholder]="searchPlaceholder()"
            [value]="searchQuery()"
            (input)="onSearchInput($event)"
            [attr.aria-label]="searchPlaceholder()"
          />
        </div>
        @if (searchQuery()) {
          <p class="search-results-count">
            {{ filteredItems().length }}
            {{ filteredItems().length === 1 ? emptyNoun() : emptyNoun() + 's' }} found
          </p>
        }
      </div>

      <mat-card class="options-card">
        <mat-card-content class="options-list-content">
          @if (pageItems().length > 0) {
            <div class="options-list">
              @for (item of pageItems(); track item.id) {
                <button type="button" class="option-item" (click)="selected.emit(item.id)">
                  <div class="option-icon-wrapper">
                    <mat-icon class="option-icon">{{ icon() }}</mat-icon>
                  </div>
                  <div class="option-info">
                    <h3 class="option-name">{{ item.name }}</h3>
                  </div>
                </button>
              }
            </div>
            @if (totalPages() > 1) {
              <div class="pagination">
                <button
                  mat-button
                  [disabled]="currentPage() <= 1"
                  (click)="goToPage(currentPage() - 1)"
                  aria-label="Previous page"
                >
                  <mat-icon>chevron_left</mat-icon>
                </button>
                <span class="pagination-info">
                  Page {{ currentPage() }} of {{ totalPages() }}
                </span>
                <button
                  mat-button
                  [disabled]="currentPage() >= totalPages()"
                  (click)="goToPage(currentPage() + 1)"
                  aria-label="Next page"
                >
                  <mat-icon>chevron_right</mat-icon>
                </button>
              </div>
            }
          } @else {
            <div class="empty-state">
              <p class="empty-state-text">
                No {{ emptyNoun() }}s found matching "{{ searchQuery() }}"
              </p>
            </div>
          }
        </mat-card-content>
      </mat-card>
    }
  </div>
</div>
